import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  checkMarketerExistence: "checkMarketerExistence [Action]",
  checkMarketerExistenceLoading: "checkMarketerExistenceLoading [Action]",
  checkMarketerExistenceAsync: "checkMarketerExistenceAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const check_marketer_existence_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.checkMarketerExistence:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.checkMarketerExistenceLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.checkMarketerExistenceLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "marketer",
    method_type: "check_marketer_existence",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.checkMarketerExistence,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.checkMarketerExistenceLoading,
      payload: false,
    });
  }
}

export function* checkMarketerExistence() {
  yield takeLatest(actionTypes.checkMarketerExistenceAsync, handleWorker);
}
